{
    "name": "pdr-team",
    "version": "0.0.64",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "build:staging": "ng build --configuration staging",
        "build:prod": "ng build --configuration production",
        "deploy:staging": "npm run build:staging && firebase deploy --only hosting:staging,firestore --project staging",
        "deploy:staging:functions": "firebase deploy --only functions --project staging",
        "deploy:prod": "npm run build:prod && firebase deploy --only hosting:app,firestore --project prod",
        "deploy:prod:functions": "firebase deploy --only functions --project prod",
        "test": "ng test",
        "lint": "ng lint"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.2.14",
        "@angular/cdk": "^19.2.19",
        "@angular/common": "^19.2.14",
        "@angular/compiler": "^19.2.14",
        "@angular/core": "^19.2.14",
        "@angular/fire": "^19.2.0",
        "@angular/forms": "^19.2.14",
        "@angular/google-maps": "^19.2.19",
        "@angular/material": "^19.2.19",
        "@angular/platform-browser": "^19.2.14",
        "@angular/platform-browser-dynamic": "^19.2.14",
        "@angular/router": "^19.2.14",
        "@ncstate/sat-popover": "^10.2.2",
        "@syncfusion/ej2-angular-schedule": "^30.1.37",
        "@types/events": "^3.0.0",
        "@types/marked": "^1.2.2",
        "algoliasearch": "^4.10.3",
        "bootstrap": "^5.3.7",
        "firebase": "^11.10.0",
        "instantsearch.js": "^4.25.2",
        "marked": "^1.2.2",
        "material": "^0.4.3",
        "ngx-quill": "^16.2.1",
        "quill": "^1.3.7",
        "quill-blot-formatter": "^1.0.5",
        "quill-emoji": "^0.2.0",
        "quill-image-resize": "^3.0.9",
        "quill-image-resize-module": "^3.0.0",
        "rxjs": "~7.8.0",
        "tslib": "^2.0.0",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/architect": "0.1902.15",
        "@angular/build": "^19.2.15",
        "@angular/cli": "^19.2.15",
        "@angular/compiler-cli": "^19.2.14",
        "@types/node": "^12.20.16",
        "@types/quill": "^1.3.7",
        "fuzzy": "^0.1.3",
        "inquirer": "^6.2.2",
        "inquirer-autocomplete-prompt": "^1.0.1",
        "jsonc-parser": "^3.0.0",
        "open": "^7.0.3",
        "ts-node": "~8.3.0",
        "tslint": "~6.1.0",
        "typescript": "^5.8.3"
    }
}
